<div
  style="display: flex;flex-direction: column;"
>
  <h5>Arzt</h5>
  <app-ordinance-detail
    [showImports]="showImports()"
  />

  <h5>Besatzung</h5>
  <app-crew-details
    [showImports]="showImports()"
  />
</div>
